import { useAtomValue } from "jotai";
import { useMemo } from "react";

import { useHtmlParser } from "@sorcery/ui";

import { deckJotai } from "~/state/deckJotai";
import { annotatePrimerMarkup, getPrimerParserOptions } from "~/utils/html";
import { CompanionDecklist } from "../../../../../components/organisms/deck/decklist/CompanionDecklist";
import { EditPrimer } from "./EditPrimer";

type Props = {
  isAuthor: boolean;
};

export const PrimerTab = ({ isAuthor }: Props) => {
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const deck = useAtomValue(deckJotai)!;
  const { mapToReactComponents } = useHtmlParser();
  const reactPrimerContent = useMemo(() => {
    return mapToReactComponents(annotatePrimerMarkup(deck.primer ?? ""), getPrimerParserOptions());
  }, [deck.primer, mapToReactComponents]);

  return (
    <div className="mb-8 flex flex-row animate-in fade-in">
      {/* Primer */}
      <div className="grow">
        {isAuthor ? (
          <EditPrimer />
        ) : (
          <div className="curiosa-primer sm:text-lg">{reactPrimerContent}</div>
        )}
      </div>
      {/* Decklist */}
      <CompanionDecklist />
    </div>
  );
};
